import {Translation} from '@/i18n/locales/type.ts';

const ja: Translation = {
  home: {
    firstVisit: '	予約なしで初めて来ました',
    returningVisitor:
      '電話番号またはメールアドレスのいずれかを入力してください。',
    error_message: {
      invalid_token: 'ネットワーク接続が不安定です。',
      search: '検索中にエラーが発生しました。',
      checkin:
        'チェックイン中にエラーが発生しました。問題が続く場合はフロントデスクにお問い合わせください。',
    },
    dialog_message: {
      reservation: {
        checked_in: '予約が確認されました。チェックインが完了しました。',
        no_customer:
          '顧客情報が見つかりませんでした。\n電話番号またはメールアドレスをもう一度確認してください。',
      },
      walkin: {
        checked_in:
          'チェックインが完了しました。少々お待ちください。順番にご案内いたします。',
        no_customer_title: 'お客様情報が見つかりませんでした。',
        no_customer_description: '初めてのご来院ですか？',
        start_first_visit: '初回受付を始める',
        no_booking_title: '{{name}}様、当日受付をご案内します。',
        no_booking_description:
          '当日受付でご相談・施術をご案内します。\n当日の状況により、お待ちいただく場合や一部の施術を承れない場合がございます。',
        start_checkin: '受付する',
      },
      no_booking: {
        title: '予約情報が見つかりません',
        description:
          '丁寧な診療と十分な相談時間の確保のため、予約制で運営しております。\nご予約済みの場合は、フロントデスクまでお問い合わせください。',
      },
      invalid_building: {
        title:
          '病院の情報が正しくありません。受付される病院が「ソウル江南ミューズクリニック本館2階」でない場合は、フロントデスクで正しい受付サイトのアドレスをご確認ください。',
      },
      common: {
        confirm: '確認',
        cancel: 'キャンセル',
      },
      confirm: {
        title: '{{name}}様、ようこそお越しくださいました！',
        description: 'ただいまチェックインを行いますか？',
        confirm: 'はい、チェックインします',
        cancel: 'いいえ',
      },
    },
    form: {
      title: {
        name: '予約者氏名',
        phone: '電話番号',
        email: 'メールアドレス',
      },
      placeholder: {
        name: '氏名を入力してください',
        phone: '電話番号を入力してください',
        email: 'メールアドレスを入力してください',
      },
      description: '電話番号またはメールアドレスのいずれかを入力してください。',
      button: {
        title: '受付する',
        loading: '検索中...',
      },
      birth: {
        title: 'お客様情報を確認するため、生年月日をご入力ください。',
        year: '年',
        month: '月',
        day: '日',
      },
    },
    customer_info: {
      title: '顧客情報',
      name: '氏名',
      phone: '電話番号',
      email: 'メールアドレス',
      button_title: 'チェックインを進める',
    },
    language_select: {
      button_title: '🌐 言語を変更 / Language',
    },
  },
  common: {
    or: 'または',
  },
  createChart: {
    title: '新規カルテ登録',
    error_message: {
      invalid_form: 'すべての情報を入力してください。',
      checkin: 'チェックイン処理中にエラーが発生しました。',
    },
    dialog_message: {
      complete: {
        title:
          'カルテ作成とチェックインが完了しました。\n当日来院の方は少々お待ちいただく場合があります。ご了承ください。',
        button_title: '確認',
      },
    },
    form: {
      name: {
        title: '予約者氏名',
        placeholder: '氏名を入力してください。',
        passport_notice:
          '正確なご予約とスムーズなサービスの提供のため、韓国国籍以外のお客様は、パスポートに記載されている英語の氏名をご入力いただきますようお願い申し上げます。',
      },
      phone: {
        title: '電話番号',
        placeholder: '電話番号を入力してください。',
      },
      email: {
        title: 'メールアドレス',
        placeholder: 'メールアドレスを入力してください。',
      },
      birth: {
        title: '生年月日',
        year: '年',
        month: '月',
        day: '日',
      },
      gender: {
        title: '性別',
        male: '男性',
        female: '女性',
      },
      button: {
        title: 'カルテ作成とチェックイン',
        loading: 'カルテ作成中...',
      },
    },
  },
};

export default ja;
